import React, { FC, useEffect } from "react";
import { Button, Heading, IconButton, Pane, PlusIcon } from "evergreen-ui";
import { useMobileMediaQuery } from "../../MediaQuery";
import { removeJcContentContainerStylesEffect } from "../../removeJcContentContainerStylesEffect";

interface TablePageHeaderProps {
    title: string;
    addButtonText?: string;
    addButtonOnClick?: () => void;
    searchBar?: React.ReactNode;
}

export const TablePageHeader: FC<TablePageHeaderProps> = (props) => {
    const isMobile = useMobileMediaQuery();

    // This removes the unwanted padding from the parent container.
    useEffect(() => removeJcContentContainerStylesEffect(false), []);

    return (
        <Pane width={"100%"} display={"flex"} alignItems={"center"}>
            <Heading
                size={800}
                style={{
                    margin: "24px",
                    width: "100%",
                    fontWeight: "unset",
                    color: `var(--grey-secondary-text)`
                }}
            >
                {props.title}
            </Heading>
            <Pane display={"flex"} gap={10} marginRight={"24px"}>
                {props.searchBar}
                {props.addButtonText && props.addButtonOnClick && (
                    !isMobile ? (
                        <Button
                            minWidth={"160px"}
                            iconBefore={PlusIcon}
                            size={"large"}
                            appearance={"primary"}
                            onClick={props.addButtonOnClick}
                        >
                            {props.addButtonText}
                        </Button>
                    ) : (
                        <IconButton
                            icon={<PlusIcon color={"white"}/>}
                            size={"large"}
                            appearance={"primary"}
                            onClick={props.addButtonOnClick}
                        />
                    )
                )}
            </Pane>
        </Pane>
    );
};
